<template>
  <div>
    <ProductFeedsForm formAction="create" />
  </div>
</template>

<script>
import ProductFeedsForm from './components/ProductFeedsForm.vue';

export default {
  components: {
    ProductFeedsForm,
  },
};
</script>
